import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ClipboardButton from '../clipboard-button/ClipboardButton';

export default function QRCodeModal({ url, entryCode, children }) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Box onClick={() => setOpen(true)} sx={{ cursor: 'pointer' }}>
                {children}
            </Box>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
                    <IconButton onClick={() => setOpen(false)} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
                <DialogContent sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    pb: 4
                }}>
                    <QRCodeSVG value={url} size={300} />
                    <Box sx={{ mt: 3, display: 'flex', alignItems: 'center' }}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold', letterSpacing: '0.1em' }}>
                            {entryCode || 'No Entry Code'}
                        </Typography>
                        <ClipboardButton text={url} />
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
}
